import React from "react";
import { ReactI18NextChild, WithTranslation, withTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

import './TemplatePage.scss';
import Icon from '../../icon/Icon';
import { TranslationKeyType } from "../../../constants/types";

interface Props extends WithTranslation {
    id: string,
    title: TranslationKeyType,
    onUndo?: () => void,
    nextEnabled: boolean,
    nextTitle?: TranslationKeyType,
    onNext: () => void,
    children?:
    | React.ReactChild
    | React.ReactChild[];
};

let hideBtnOn = ['final-page', 'error-page']
class TemplatePage extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const { t, id, title, onUndo, children, nextEnabled, nextTitle = "general.continue", onNext } = this.props;
        return <div key={id} className="render-page">
            <header className="page-header">
                <div className={`page-header-undo fade-in ${onUndo == undefined ? "undo-hidden" : ""}`}>
                    {!hideBtnOn.includes(id) && <Icon type="BACKARROW" iconProps={{ size: '1.75rem' }} onClick={onUndo} />}
                </div>
                <div className="page-header-title fade-in">
                    {t(title as unknown as TemplateStringsArray)}
                </div>
            </header>
            <main className="page-body">
                <div className="page-body-container">
                    {children}
                </div>
            </main>
            <footer className="page-footer">
                {!hideBtnOn.includes(id) && <Button disabled={!nextEnabled} onClick={onNext}>{t(nextTitle as unknown as TemplateStringsArray)}</Button>}
            </footer>
        </div>;
    }
};

export default withTranslation()(TemplatePage);